module.exports = __webpack_public_path__ + "media/10no-five.cc0a6d1b.mp3";